export const formatLegacyPhoneNumber = (val: unknown) => {
  const digitsOnly = String(val).replace(/\D/g, '');

  if (digitsOnly.length !== 10) {
    return val;
  }

  return `(${digitsOnly.substring(0, 3)}) ${digitsOnly.substring(
    3,
    6
  )}-${digitsOnly.substring(6)}`;
};
